module.exports = __webpack_public_path__ + "img/108bb97.png";